/**
 * state/instance.ts — единая фабрика CardInstance с КАНОНИЧЕСКИМ порядком ключей.
 *
 * Байт-стабильность serialize (tech/25 §1, tech/26 §4) зависит от порядка
 * вставки ключей: экземпляры, рождённые разными путями (тест-builder,
 * TokenCreated-reducer, вскрытие плана в M4), обязаны иметь ОДИНАКОВЫЙ порядок
 * ключей — иначе логически равные состояния дают разные байты/golden-хэши.
 * Порядок фиксирован здесь: id, seq, defId, ownerId, zone, cellId?, isToken?,
 * stats, vars (как в tech/21 §2).
 */
import { normalizeZero } from './num.js';
/**
 * Собрать CardInstance в каноническом порядке ключей. stats копируются
 * (никаких разделяемых ссылок с вызывающим), vars глубоко клонируются.
 */
export function makeCardInstance(init) {
    return {
        id: init.id,
        seq: init.seq,
        defId: init.defId,
        ownerId: init.ownerId,
        controllerId: init.controllerId ?? init.ownerId,
        zone: init.zone,
        ...(init.cellId !== undefined ? { cellId: init.cellId } : {}),
        ...(init.isToken === true ? { isToken: true } : {}),
        ...(init.enteredRound !== undefined ? { enteredRound: init.enteredRound } : {}),
        ...(init.heat !== undefined ? { heat: init.heat } : {}),
        ...(init.freeze !== undefined ? { freeze: init.freeze } : {}),
        ...(init.hack !== undefined ? { hack: structuredClone(init.hack) } : {}),
        stats: {
            attack: normalizeZero(init.stats.attack),
            health: normalizeZero(init.stats.health),
            maxHealth: normalizeZero(init.stats.maxHealth),
        },
        vars: init.vars !== undefined ? structuredClone(init.vars) : {},
    };
}
//# sourceMappingURL=instance.js.map